import { DatePipe } from "@angular/common";
import { Component, OnInit, TemplateRef, ViewChild, HostListener } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { ActivatedRoute } from "@angular/router";
import { EntityPagedResult, MessageChannelService, messageLevel } from "@bndes/bndes-ux4/bndes-angular-utils";
import { BnModalMessageService } from "@bndes/bndes-ux4/bn-modal-message";
import moment from "moment";
import { ROLE_GESTOR_ENVIO } from "src/app/constantes/permissao.constants";
import { AgenteFinanceiro } from "src/app/model/agente-financeiro.model";
import { IrregularidadeOperacaoGarantida, TIPO_CLASSE_OPERACAO } from "src/app/model/operacao-irregular.model";
import { PermissaoService } from 'src/app/shared/permissao.service';
import { IrregularidadeService } from "../irregularidade.service";

@Component({
    templateUrl: './irregularidade-pesquisa.component.html',
    standalone: false
})
export class IrregularidadePesquisaComponent implements OnInit {

    private cnpjUsuario: string;
    private pesquisaForm: UntypedFormGroup = null;
    private opcoesPaginacao: number[];
    private irregularidades: IrregularidadeOperacaoGarantida[] = [];
    private agentesFinanceiros: AgenteFinanceiro[] = [];
    private atributosPaginacaoComponenteListagem: EntityPagedResult<IrregularidadeOperacaoGarantida>;
    private podeCadastrarIrregularidade: boolean = true;
    private classesOperacao = TIPO_CLASSE_OPERACAO;
    private valoresPesquisaForm: any;
    private dataHoraResultado: string;
    public pesquisado: boolean = false;
    public esconderPesquisa: boolean = true;
    public irregularidadeDesativando: IrregularidadeOperacaoGarantida;
    @ViewChild('desativacao') desativacao: TemplateRef<any>;
    @ViewChild('desativacaoBotoes') desativacaoBotoes: TemplateRef<any>;
    
    constructor(
        private formBuilder: UntypedFormBuilder,
        private activatedRoute: ActivatedRoute,
        private permissaoService: PermissaoService,
        private irregularidadeService: IrregularidadeService,
        private messageService: MessageChannelService,
        private modalService: BnModalMessageService,
        private datePipe:DatePipe
    ) {

        this.opcoesPaginacao = [10, 15, 20];
        this.atributosPaginacaoComponenteListagem = {
            page: 1,
            pageSize: this.opcoesPaginacao[0],
            pages: undefined,
            count: undefined,
            list: undefined
        };
        this.agentesFinanceiros = this.activatedRoute.snapshot.data['agentes'];
    }

    @HostListener('window:keydown.enter', ['$event'])
    keyEvent(event: KeyboardEvent) {
      this.buscar();
    }


    ngOnInit(): void {

        this.pesquisaForm = this.createReactiveForm();

        this.permissaoService.getPermissoesUsuarioAutenticado().subscribe((resp: any) => {
            this.podeCadastrarIrregularidade = resp && resp[ROLE_GESTOR_ENVIO];
            this.construirFormulario();
            sessionStorage.getItem('irregularidadesPesquisada')==='S' && this.buscar() ;
        });
    }

    createReactiveForm(): UntypedFormGroup {

        const f = this.formBuilder.group({
            agenteFinanceiro: null,
            classeOperacao: null,
            idOperacaoExterno:  [null,[Validators.pattern(/^[A-Za-z0-9_\-]+$/),Validators.minLength(1), Validators.maxLength(20)]],
            contratoRepasse:    [null,[Validators.pattern(/^[0-9]+$/),Validators.minLength(11), Validators.maxLength(11)]],
            situacao:null,
            motivo: null,
            dataDesativacaoInicial: null,
            dataDesativacaoFinal: null,
        });

        f.get('classeOperacao').valueChanges.subscribe(sist => {
            const contratoRepasse = f.get('contratoRepasse');
            const idOperacaoExterno = f.get('idOperacaoExterno');
            if (!sist) {
                idOperacaoExterno.enable();
                contratoRepasse.enable();
                return;
            }
            if (sist === 'CL') {
                idOperacaoExterno.enable();
                contratoRepasse.disable();
            } else {
                contratoRepasse.enable();
                idOperacaoExterno.disable();
            }
            contratoRepasse.updateValueAndValidity();
            idOperacaoExterno.updateValueAndValidity();
        });

        return f;
    }


    private construirFormulario() {
        
        const valoresSessao = sessionStorage.getItem('valoresPesquisaIrregularidadeForm');
        this.valoresPesquisaForm = valoresSessao ? JSON.parse(valoresSessao) : null;

        if (this.valoresPesquisaForm) {
            const agenteSelecionado = this.retornaAgenteFinanceiro(this.valoresPesquisaForm.agenteFinanceiro?.id);
            this.pesquisaForm.setValue({
                agenteFinanceiro: agenteSelecionado,
                classeOperacao: this.valoresPesquisaForm.classeOperacao ? this.valoresPesquisaForm.classeOperacao : null,
                contratoRepasse: this.valoresPesquisaForm.contratoRepasse ? this.valoresPesquisaForm.contratoRepasse : null,
                situacao: this.valoresPesquisaForm.situacao || null,
                idOperacaoExterno: this.valoresPesquisaForm.idOperacaoExterno ? this.valoresPesquisaForm.idOperacaoExterno : null,
                motivo: this.valoresPesquisaForm.motivo ? this.valoresPesquisaForm.motivo : null,
                dataDesativacaoInicial: this.valoresPesquisaForm.dataDesativacaoInicial ? this.valoresPesquisaForm.dataDesativacaoInicial : null,
                dataDesativacaoFinal: this.valoresPesquisaForm.dataDesativacaoFinal ? this.valoresPesquisaForm.dataDesativacaoFinal : null,
            });

        }
        this.pesquisaForm.valueChanges.pipe().subscribe(novosValores => {
            this.valoresPesquisaForm = novosValores;
            sessionStorage.setItem('valoresPesquisaIrregularidadeForm', JSON.stringify(this.valoresPesquisaForm));
        });
    }

    mudancaPagina(novaPagina: EntityPagedResult<IrregularidadeOperacaoGarantida>) {
        this.atributosPaginacaoComponenteListagem = novaPagina;
        this.esconderPesquisa = true;
        this.buscar();
    }

    retornaAgenteFinanceiro(id: number) {
        return id ? this.agentesFinanceiros
            .filter(agente => agente.id == id)[0] : null;
    }

    limpar() {
        this.pesquisaForm.reset({
            classeOperacao: null
        });
        this.irregularidades = [];
        this.pesquisado = false;
        this.atributosPaginacaoComponenteListagem.page = 1;
        sessionStorage.setItem('irregularidadesPesquisada','N');
    }

    buscar() {
        if(!this.esconderPesquisa){
            this.atributosPaginacaoComponenteListagem.page = 1;
        }
        this.irregularidadeService.getIrregularidades(this.obterFiltrosBusca()).subscribe(
            response => {
                this.dataHoraResultado = moment().format('YYYY-MM-DD HH:mm:ss');
                this.irregularidades = response.resultados;
                this.atributosPaginacaoComponenteListagem.count = response ? response.totalRegistrosSemPaginacao : 0;
                this.pesquisado = true;
                this.esconderPesquisa = false;
            });
        sessionStorage.setItem('irregularidadesPesquisada','S');
    }

    obterFiltrosBusca() {
        const form = this.pesquisaForm.value;
        let dadosPreenchidos: any = {};

        if (form.agenteFinanceiro)
            dadosPreenchidos.idAgenteFinanceiro = form.agenteFinanceiro.id;
        if (form.classeOperacao)
            dadosPreenchidos.classeOperacao = form.classeOperacao;
        if (form.idOperacaoExterno)
            dadosPreenchidos.idOperacaoExterno = form.idOperacaoExterno;
        if (form.contratoRepasse)
            dadosPreenchidos.contratoRepasse = form.contratoRepasse;
        if (form.motivo) {
            dadosPreenchidos.motivo = form.motivo;
        }
        if(!(form.situacao==='null')){
            dadosPreenchidos.situacao = form.situacao;
        }
        if(form.dataDesativacaoInicial){
            dadosPreenchidos.dataDesativacaoInicial = this.datePipe.transform(form.dataDesativacaoInicial,"yyyyMMdd");
        }
        if(form.dataDesativacaoFinal){
            dadosPreenchidos.dataDesativacaoFinal =  this.datePipe.transform(form.dataDesativacaoFinal,"yyyyMMdd");
        }
        
        dadosPreenchidos.pagina = this.atributosPaginacaoComponenteListagem.page;
        dadosPreenchidos.limite = this.atributosPaginacaoComponenteListagem.pageSize;

        return dadosPreenchidos;

    }

        
  desativacaoIrregularidade(irregularidade: IrregularidadeOperacaoGarantida) {
    this.irregularidadeDesativando = irregularidade;
    this.irregularidadeDesativando.dataFim = this.retornaDataFim(irregularidade.dataInicio);
    this.modalService
      .abrir('Desativação de irregularidade', null, 'lg', this.desativacao, this.desativacaoBotoes).result
      .then((irregularidade) => {
            this.messageService.addMessage({
                title: 'Sucesso',
                type: 'CRUD_OPERATION',
                level: messageLevel.SUCCESS,
                message: 'Irregularidade desativada com sucesso.'
            });
            this.buscar();
        }, (reason) => {
          console.log(reason);
        }
      );
  }
  
  confirmaDesativacao() {
    
    this.irregularidadeService['save'](this.irregularidadeDesativando)
        .subscribe(irregularidadeDesativada => {
            this.modalService.close(irregularidadeDesativada);
        }, error => {
            console.log(error);
        });        
  }

  cancelaDesativacao() {
    this.irregularidadeDesativando.dataFim = null;
    this.modalService.dismiss("abortou desativação");
  }

  retornaDataFim(dataInicio:string): string {
      let dataFim:any = moment().format('YYYY-MM-DD');
      if(moment(dataFim).isAfter(dataInicio)){
          let data = moment(dataFim).subtract(1);
          //return this.datePipe.transform(data.date(),'yyyy-MM-dd');
          return data.format('YYYY-MM-DD');
      }
      if(moment(dataInicio).isSame(dataFim)){
          return dataFim.toString();
      }

      return dataInicio;
  }

}
